import React from 'react';
import { ExtendedCategoryItem } from '../types';
import styles from './List.module.scss';
import SectionHeader from '../../SectionHeader/SectionHeader';

interface ListCategoryPropTypes {
  handleItemClick: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>,
    item: ExtendedCategoryItem
  ) => void;
  title?: string;
  items?: ExtendedCategoryItem[];
}

const List: React.FC<ListCategoryPropTypes> = ({
  title,
  items,
  handleItemClick,
}) => {
  if (!items || !items.length) return null;

  return (
    <>
      <SectionHeader heading={title} />
      <ul className={styles.listWrapper} data-testid="list-wrapper">
        {items.map((item, index) => (
          <div>
            <a
              key={index}
              className={styles.item}
              onClick={e => handleItemClick(e, item)}
              href={item.route_link ? item.route_link : item.url || ''}
              target={item.target || ''}
              rel={`${item.notIndexed ? 'nofollow' : ''}`}
            >
              <img
                data-testid="image"
                className={styles.image}
                src={item.image?.source || ''}
                alt={item.image?.alt || ''}
              />
              <div className={styles.mainInfoWrapper}>
                {item.description && (
                  <p className={styles.description}>{item.description}</p>
                )}
                <span className={styles.title}>{item.title}</span>
              </div>
            </a>
          </div>
        ))}
      </ul>
    </>
  );
};

export default List;
